import { PRODUCTS_CREATE_PATH, PRODUCTS_EDIT_PATH, PRODUCTS_LIST_PATH } from 'shared/constants/routes';
import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
import { PermissionsEnum } from 'types/permissions/enums';
// Lazy-load the page entries, not the module index.
var ProductsList = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/ProductsList');
});
var ProductCreate = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/ProductCreate');
});
var ProductEdit = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/ProductEdit');
});
// Mounts the products pages; BaseRouting owns the feature-flag switch.
export var Routing = function Routing() {
    return RouteGenerator({
        create: {
            path: PRODUCTS_CREATE_PATH,
            component: ProductCreate,
            exact: true,
            permission: PermissionsEnum.ProductsManage
        },
        edit: {
            path: PRODUCTS_EDIT_PATH,
            component: ProductEdit,
            exact: true,
            permission: PermissionsEnum.ProductsManage
        },
        list: {
            path: PRODUCTS_LIST_PATH,
            component: ProductsList,
            exact: true
        }
    });
};
